import { render, staticRenderFns } from "./UDRecord.vue?vue&type=template&id=58ac05ae"
import script from "./UDRecord.vue?vue&type=script&lang=js"
export * from "./UDRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports